<template>
  <div>
    <v-progress-linear
      background-color="grey lighten-4"
      height="24"
      :value="(current + 1) / quizzes.length * 100"
    ></v-progress-linear>
    <v-container pt-0>
      <div style="height: 96px;"></div>

      <v-row justify="center">
        <v-col sm="12" md="6">
          <p :class="mobile ? 'bold-18' : 'bold-24'">
            {{ `${current + 1}. ` }}
            <span v-html="quiz.qeustion"></span>
          </p>
          <div style="height: 18px;"></div>

          <my-container
            v-if="quiz.sentences"
            regular
            style="border: 1px solid #f2f2f2; justify-content: center;"
          >
            <div>
              <div v-for="(sentence, index) in quiz.sentences" :key="'sentence' + index">
                <p
                  v-html="sentence.text"
                  :class="(mobile ? 'bold-24' : 'bold-32') + ' text-center'"
                ></p>
                <p
                  v-if="sentence.pinyin"
                  v-html="sentence.pinyin"
                  :class="(mobile ? 'regular-18' : 'regular-24') + ' text-center'"
                ></p>
              </div>
            </div>
          </my-container>
          <div v-if="quiz.sentences" style="height: 44px;"></div>

          <v-radio-group v-model="selected">
            <v-radio v-for="(item, index) in quiz.items" :key="'item' + index" class="mb-6">
              <template v-slot:label>
                <span
                  :class="mobile ? 'regular-20' : 'regular-28'"
                  v-html="item"
                  style="color: #000000;"
                ></span>
              </template>
            </v-radio>
          </v-radio-group>

          <my-container v-if="quiz.comment" regular style="background-color: #f2f2f2;">
            <v-img
              contain
              :src="require('../assets/face.svg')"
              :height="mobile ? 36 : 52"
              style="align-self: start;"
            ></v-img>
            <div style="width: 12px;"></div>
            <p v-html="quiz.comment" class="mb-0" style="color: #828282;"></p>
          </my-container>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col v-if="current !== 0" sm="6" md="3">
          <my-button color="primary" outlined @click="prev()">이전</my-button>
        </v-col>
        <v-col :sm="current === 0 ? 12 : 6" :md="current === 0 ? 6 : 3">
          <my-button color="primary" depressed :disabled="selected === null" @click="next()">다음</my-button>
        </v-col>
      </v-row>

      <div style="height: 80px;"></div>
    </v-container>
  </div>
</template>

<script>
import MyButton from "../components/MyButton";
import MyContainer from "../components/MyContainer";

export default {
  components: { MyButton, MyContainer },
  data: () => ({
    quizzes: [
      {
        qeustion:
          '<span style="color: #14a172;">国</span>은 어떤 한자의 중국어 *간체자일까요?',
        items: ['<span style="color: #14a172;">國</span>', "風"],
        comment:
          "*간체자란?<br />중국에서 본래의 복잡한 한자 점획을 간단하게 변형시켜 만들어낸 글자를 의미해요!"
      },
      {
        qeustion:
          '‘東<span style="color: #949495;">西</span>(dōng xi)’의 뜻은 무엇일까요?',
        items: ["물건", "동쪽과 서쪽"]
      },
      {
        qeustion:
          '‘生<span style="color: #fc7569;">氣</span>(shēng qì)’의 뜻은 무엇일까요?',
        items: ["기운이 나다", "화나다"]
      },
      {
        qeustion: "소심하다의 ‘소심’은 중국어로 무엇일까요?",
        items: [
          '<span style="color: #f3af2e;">小</span>说 (xiǎoshuō)',
          '<span style="color: #f3af2e;">小</span><span style="color: #14a172;">小</span> (xiǎoshí)',
          '<span style="color: #f3af2e;">小</span>心 (xiǎoxīn)'
        ]
      },
      {
        qeustion: "'감동'은 중국어로 무엇일까요?",
        items: [
          '<span style="color: #f3af2e;">感</span><span style="color: #fc7569;">謝</span> (gǎnxiè)',
          '<span style="color: #f3af2e;">感</span><span style="color: #fc7569;">动</span> (gǎndòng)',
          '<span style="color: #fc7569;">運動</span> (yùndòng)'
        ]
      },
      {
        qeustion: "아래 문장의 뜻은 무엇일까요?",
        sentences: [
          {
            text:
              '多<span style="color: #f3af2e;">少</span><span style="color: #14a172;">钱</span>？',
            pinyin: "Duō shǎo qián?"
          }
        ],
        items: ["몇 개에요?", "얼마예요?"]
      },
      {
        qeustion: "아래 문장의 뜻은 무엇일까요?",
        sentences: [
          {
            text:
              '<span style="color: #f3af2e;">你有手</span>机<span style="color: #949495;">吗</span>?',
            pinyin: "Nǐ yǒu shǒujī ma?"
          }
        ],
        items: ["나 좀 도와줄래?", "핸드폰 있어?"]
      },
      {
        qeustion: "아래 문장의 뜻은 무엇일까요?",
        sentences: [
          {
            text:
              '<span style="color: #f3af2e;">我</span><span style="color: #fc7569;">住在</span>家<span style="color: #949495;">里</span>。',
            pinyin: "Wŏ zhù zài jiāli."
          }
        ],
        items: ["나는 집에서 살고 있습니다.", "나는 지금 집에 있습니다."]
      },
      {
        qeustion: "아래 대화문에서 A가 한 말은 무엇일까요?",
        sentences: [
          {
            text:
              'A : <span style="text-decoration: underline; white-space: pre;">                              </span>'
          },
          {
            text:
              'B : <span style="color: #f3af2e;">五口</span><span style="color: #14a172;">人</span>。',
            pinyin: "(Wǔ kǒu rén)"
          }
        ],
        items: [
          '<span style="color: #f3af2e;">你</span>家<span style="color: #f3af2e;">有几口</span><span style="color: #14a172;">人</span>? (Nǐ jiā yǒu jǐkǒu rén?)',
          '<span style="color: #f3af2e;">你姐姐</span>多<span style="color: #fc7569;">大</span>? (Nǐ jiějiě duōdà?)'
        ]
      },
      {
        qeustion: "아래 대화문에서 B가 한 말은 무엇일까요?",
        sentences: [
          {
            text:
              'A : <span style="color: #f3af2e;">你</span><span style="color: #fc7569;">是</span><span style="color: #14a172;">韓國人</span><span style="color: #949495;">吗</span>?',
            pinyin: "(Nǐ shì hánguórén ma ?)"
          },
          {
            text:
              'B : <span style="text-decoration: underline; white-space: pre;">                              </span>'
          }
        ],
        items: [
          '<span style="color: #fc7569;">是</span>, <span style="color: #f3af2e;">我</span><span style="color: #fc7569;">是</span><span style="color: #14a172;">韓國人</span>。(Shì, wǒ shì hánguórén.)',
          '<span style="color: #fc7569;">是</span>, <span style="color: #f3af2e;">我</span><span style="color: #949495;">的</span><span style="color: #14a172;">朋</span><span style="color: #f3af2e;">友</span>。(Shì, wŏ de péngyŏu.)'
        ]
      }
    ],
    rightAnswers: [0, 0, 1, 2, 1, 1, 1, 0, 0, 0],
    current: 0,
    selected: null,
    answers: []
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    quiz() {
      return this.quizzes[this.current];
    }
  },
  methods: {
    prev() {
      if (this.current <= 0) return;
      this.current--;
      this.$amplitude
        .getInstance()
        .logEvent("Button Prev Clicked", { to: this.current });
    },
    next() {
      if (this.answers.length > this.current) {
        this.answers[this.current] = this.selected;
      } else {
        this.answers.push(this.selected);
      }
      this.selected = null;

      if (this.current + 1 >= this.quizzes.length) {
        const score = this.answers.filter(
          (answer, index) => answer === this.rightAnswers[index]
        ).length;
        const properties = { score };
        this.answers.forEach((answer, index) => {
          properties[`quiz ${index + 1}`] = {
            answer: answer + 1,
            right: answer === this.rightAnswers[index]
          };
        });
        this.$amplitude.getInstance().logEvent("Test finished", properties);
        this.$router.push(`/result?score=${score}`);
      } else {
        this.current++;
        this.$amplitude
          .getInstance()
          .logEvent("Button Next Clicked", { to: this.current });
      }
    }
  },
  created() {
    this.$amplitude.getInstance().logEvent("Page Test Viewed");
  }
};
</script>

<style>
</style>
